import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Input,
  Label,
  Row,
  Container
} from "reactstrap";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import { formatDateStringToKorea } from "helpers/format";
import { unique } from "helpers/validate_yup";
import UploadImageSingle from "components/Common/UploadImageSingle";
import DropdownPlatform from "components/Common/DropdownPlatform";
import DropdownCountries from "components/Common/DropdownCountries";

export interface Props {
  user?: any;
  setLinkImage?: any;
  listCountry?: []
}

registerLocale("en", en);
registerLocale("ko", ko);

Yup.addMethod(Yup.array, "unique", unique);

const UserOverview = ({
  user = "",
  setLinkImage,
  listCountry=[]
}: Props) => {
  const { t, i18n } = useTranslation();

  const [platFormSelected, setPlatFormSelected] = useState<any>(null);

  const formik = useFormik({
    initialValues: {
      profile_image_url: "",
      agency_code: "",
      agency_name: "",
      name: "",
      email: "",
      country_code: null,
      ip: "",
      created_at: new Date(),
    },
    onSubmit: () => {},
  });

  const handleSetValueForm = (valueDefault: any) => {
    formik.setValues({
      ...valueDefault,
      created_at: valueDefault?.created_at ? new Date(formatDateStringToKorea(valueDefault?.created_at)) : null,
      courses: valueDefault?.agency_params ?? []
    });
  };

  useEffect(() => {
    handleSetValueForm(user);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    document.title = `${t("User Detail")} - ${t("Users Management")} | Picaverse Agency Star+`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <div className="mt-3">
            <>
              <form onSubmit={formik.handleSubmit}>
                <Row className="modal-custom-scroll" style={!user ? {overflowY: "auto", maxHeight: "68vh"} : {overflowY: "auto"}}>
                  <Col xxl={12}>
                    <div className="mb-3">
                      <label className="form-label">
                        {t("Avatar")}
                      </label>

                      <UploadImageSingle
                        data={formik.getFieldProps("profile_image_url")?.value}
                        setLinkImage={setLinkImage}
                        formik={formik}
                        isMultiple={false}
                        formikNameImage={"avatar"}
                        isDisabled={true}
                      />
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="mb-3">
                      <Label htmlFor="nickname" className="form-label">
                        {t("Nickname")}<span className="text-danger"> *</span>
                      </Label>
                      <Input
                        name="nickname"
                        type="text"
                        className="form-control"
                        id="nickname"
                        disabled={true}
                        placeholder={t("No data")}
                        value={formik?.values?.name}
                        onChange={(event: any) =>
                          formik.setFieldValue(
                            "nickname",
                            event?.target?.value
                          )
                        }
                      />
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="mb-3">
                      <Label htmlFor="email" className="form-label">
                        {t("Email")}<span className="text-danger"> *</span>
                      </Label>
                      <Input
                        name="email"
                        type="text"
                        className="form-control"
                        id="email"
                        disabled={true}
                        placeholder={t("No data")}
                        value={formik?.values?.email}
                        onChange={(event: any) =>
                          formik.setFieldValue(
                            "email",
                            event?.target?.value
                          )
                        }
                      />
                    </div>
                  </Col>

                  <Col xxl={6}>
                    <div className="mb-3">
                      <Label className="form-label">
                        {t("Platform")}<span className="text-danger"> *</span>
                      </Label>

                      <DropdownPlatform
                        name="platform"
                        placeholder={`${t("Platform")}...`}
                        className="dropdown-status-rounded"
                        classNamePrefix="name-prefix"
                        initialValue={platFormSelected || null}
                        onChangeSelect={(e: any) => setPlatFormSelected(e)}
                        isHasOptionAll={false}
                        disabled={true}
                      />
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="mb-3">
                      <Label htmlFor="ip" className="form-label">
                        {t("IP")}<span className="text-danger"> *</span>
                      </Label>
                      <Input
                        name="ip"
                        type="text"
                        className="form-control"
                        id="ip"
                        disabled={true}
                        placeholder={t("No data")}
                        value={formik?.values?.ip}
                        onChange={(event: any) =>
                          formik.setFieldValue(
                            "ip",
                            event?.target?.value
                          )
                        }
                      />
                    </div>
                  </Col>

                  <Col xxl={6}>
                    <div className="mb-3">
                      <Label className="form-label">
                        {t("Country")}<span className="text-danger"> *</span>
                      </Label>

                      <DropdownCountries
                        name="country_code"
                        dataList={listCountry || []}
                        placeholder={`${t("Select Country")}...`}
                        className="dropdown-status-rounded"
                        classNamePrefix="name-prefix"
                        initialValue={formik?.values?.country_code}
                        onChangeSelect={(e: any) => {}}
                        isHasOptionAll={false}
                        disabled={true}
                      />
                    </div>
                  </Col>

                  <Col lg={6} className="datepicker-time">
                    <div className="mb-3">
                      <Label htmlFor="created_at" className="form-label">
                        {t("Created at")}
                      </Label>

                      <div className="w-100">
                        <DatePicker
                          name={"created_at"}
                          className="form-control"
                          selected={formik?.values?.created_at}
                          disabled={true}
                          placeholderText={`${t("No data")}`}
                          onChange={(date: any) => {
                            formik.setFieldValue("created_at", date);
                          }}
                          dateFormat="yyyy-MM-dd HH:mm:ss"
                          isClearable={false}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </form>
            </>
          </div>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default UserOverview;
